/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Billing_Cycle_HintInputs */

const en_admin_resource_form_billing_cycle_hint = /** @type {(inputs: Admin_Resource_Form_Billing_Cycle_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of months (1–12)`)
};

const de_admin_resource_form_billing_cycle_hint = /** @type {(inputs: Admin_Resource_Form_Billing_Cycle_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Monate (1–12)`)
};

const es_admin_resource_form_billing_cycle_hint = /** @type {(inputs: Admin_Resource_Form_Billing_Cycle_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de meses (1–12)`)
};

const fr_admin_resource_form_billing_cycle_hint = /** @type {(inputs: Admin_Resource_Form_Billing_Cycle_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de mois (1–12)`)
};

/** @type {(inputs: Admin_Resource_Form_Billing_Cycle_HintInputs) => LocalizedString} */
const it_admin_resource_form_billing_cycle_hint = en_admin_resource_form_billing_cycle_hint;

/** @type {(inputs: Admin_Resource_Form_Billing_Cycle_HintInputs) => LocalizedString} */
const pt_br2_admin_resource_form_billing_cycle_hint = en_admin_resource_form_billing_cycle_hint;

/** @type {(inputs: Admin_Resource_Form_Billing_Cycle_HintInputs) => LocalizedString} */
const pl_admin_resource_form_billing_cycle_hint = en_admin_resource_form_billing_cycle_hint;

/** @type {(inputs: Admin_Resource_Form_Billing_Cycle_HintInputs) => LocalizedString} */
const hu_admin_resource_form_billing_cycle_hint = en_admin_resource_form_billing_cycle_hint;

/** @type {(inputs: Admin_Resource_Form_Billing_Cycle_HintInputs) => LocalizedString} */
const ro_admin_resource_form_billing_cycle_hint = en_admin_resource_form_billing_cycle_hint;

/**
* | output |
* | --- |
* | "Number of months (1–12)" |
*
* @param {Admin_Resource_Form_Billing_Cycle_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_billing_cycle_hint = /** @type {((inputs?: Admin_Resource_Form_Billing_Cycle_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Billing_Cycle_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_billing_cycle_hint(inputs)
	if (locale === "de") return de_admin_resource_form_billing_cycle_hint(inputs)
	if (locale === "es") return es_admin_resource_form_billing_cycle_hint(inputs)
	if (locale === "fr") return fr_admin_resource_form_billing_cycle_hint(inputs)
	if (locale === "it") return it_admin_resource_form_billing_cycle_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_billing_cycle_hint(inputs)
	if (locale === "pl") return pl_admin_resource_form_billing_cycle_hint(inputs)
	if (locale === "hu") return hu_admin_resource_form_billing_cycle_hint(inputs)
	return ro_admin_resource_form_billing_cycle_hint(inputs)
});
export { admin_resource_form_billing_cycle_hint as "admin.resource_form.billing_cycle_hint" }